import { Tooltip } from '../..'
import { ORDER } from '../../../config/constants'
import {
  ArrowAsc,
  ArrowDes,
  ArrowsWrapper,
  HeaderBtn,
  HeaderGrid
} from './styles'

const Header = ({
  isOrdered,
  order,
  tooltip,
  onClick,
  children,
}) => {

  const isOrderAsc = isOrdered && order === ORDER.asc
  const isOrderDes = isOrdered && order === ORDER.desc

  const Wrapper = ({ children }) => onClick
    ? <HeaderBtn onClick={onClick}>{children}</HeaderBtn>
    : <div>{children}</div>

  return (
    <HeaderGrid>
      <Wrapper>
        {children}

        {isOrdered && (
          <ArrowsWrapper>
            <ArrowAsc $isActive={isOrderAsc} />
            <ArrowDes $isActive={isOrderDes} />
          </ArrowsWrapper>
        )}
      </Wrapper>

      {tooltip && <Tooltip place='bottom'>{tooltip}</Tooltip>}
    </HeaderGrid>
  )
}

export default Header